export enum CType {
    Physical = 'plastic',
    Virtual = 'virtual',
}

export enum CStatus {
    New = 'new',
    Dispatched = 'dispatched',
    SoftBlocked = 'soft_blocked',
    Active = 'active',
    Blocked = 'blocked',
    Closed = 'closed',
    Suspended = 'suspended',
    Personalized = 'personalized',
    None = 'none',
}

export type Card = {
    id: number;
    cardId: number;
    status: CStatus;
    type: CType;
    cardholder: string;
    created: string;
    updated: string;
    activated: string;
    expirationDate: string;
    numberMasked: string;
    isEnrolled: number;
    '3d_secure_settings': {
        type: string;
        mobile: string;
        password: string;
        email: string;
    };
    googlePayProvisioned: number;

    // CVV, CardNumber не храним в памяти, Получили -> Отобразили -> забыли;
};

export type Application = {
    id: string;
    account_id: string;
    name: string;
    address: string;
    country: string;
    city: string;
    status: string;
    type: string;
    first_name: string;
    last_name: string;
    postal_code: string;
    phone_number: string;
    card_number_masked: string;
    card_delivery_method_id: string;
};
